<template>
    <div class="page-container-v2">
        <page-header
            :title="$t('itemslist_title')"
            :sub-title="$t('itemslist_desc')"
        >
            <template #rightArea>
                <a-button
                    type="primary"
                    @click="routeToAddItem"
                    >

                    <i class="fa-regular fa-plus"/>
                    {{ $t('itemslist_add_item') }}
                </a-button>
            </template>
        </page-header>
        <div class="table-with-search">
            <div class="table-info-filter">
                <div class="total-div">
                    <p>
                        {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                    </p>
                </div>
                <div class="search-container">
                    <a-select 
                        v-model:value="rowsPerPage" 
                        @change="handleRowsPerPage"
                        style="width: 150px;"
                    >
                        <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                        <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                        <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                    </a-select>
                    <div class="search-div">
                        <a-select 
                            v-model:value="searchFilter" 
                            id="searchFilter" 
                            class="no-radius-right"
                            :placeholder="$t('productslist_search_choose')"
                            style="width: 100px"

                        >
                            <a-select-option value="" selected>
                                {{ $t('productslist_search_choose') }}
                            </a-select-option>
                            <a-select-option value="itemName">
                                {{ $t('productslist_search_item_name') }}
                            </a-select-option>
                            <a-select-option value="itemCode">
                                {{ $t('itemslist_search_item_code') }}
                            </a-select-option>
                        </a-select>
                        <div class="typing-area">
                            <a-input
                                :placeholder="$t('itemslist_search_placeholder')"
                                v-model:value="condition"
                                @keyup.enter="enter"
                                class="no-radius-all"
                                style="height: 100%; width: 250px;"
                            />
                            <a-button 
                                @click="enter"
                                class="black no-radius-left" 
                                style="height: 100%;"
                            >
                                {{ $t('productslist_search') }}
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
            <a-table 
                class="ant-table-striped"
                size="small"
                :columns="columns"
                :data-source="responseData"
                :pagination="false"
                v-if="responseData.length > 0"
            >
                    <template #bodyCell="{ column, record }">
                    </template>
            </a-table>
            <div class="no-result-container" v-else>
                <i class="fa-solid fa-exclamation-triangle" />
                <span>{{ computedNoResultMessage }} </span>
            </div>
        </div>
        <pagination 
            v-if="!$store.state.isLoading && responseData.length > 0"
            :page-info="paginationData"
            page-name="ItemList"
            @change-page="paginationHandler"
        />
    </div>
</template>

<script>
import { getAccessToken } from '@/utils/tokenStore';
import { 
    convertDate, 
    oneBtnDialog, 
    confirmDialog, 
    jwtDecoder,
    formatCommaNumber,
} from '@/utils/utils';
import {
    enums,
    MedicalDept,
} from '@/utils/enums'
import NoResult from '@/views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';
import PageHeader from '@/views/components/PageHeader.vue';

export default {
    name: 'ItemList',
    components: {
        NoResult,
        Pagination,
        PageHeader,
    },
    computed: {
        computedNoResultMessage() {
        if(this.calledApiTimes <= 1) {
            return this.$i18n.t('noresult_item');
        } else {
            return this.$i18n.t('noresult_search');
        }
        },
    },
    data() {
        return {
        formatCommaNumber,
        addItemPath: '/item/add',
        modalData: '',
        isInputFocused: false,

        // 목록 받아오는 변수
        responseData: [],

        // 페이지네이션 관련 변수
        searchFilter: undefined,
        previousCondition: '',
        condition: '',
        calledApiTimes: 0,

        selectedItem: '',
        itemDetailData: {},
        deptList: [],
        isZeiss: false,

        columns:[
                {
                    key: 'index', title: this.$t('itemslist_table_no'), dataIndex: 'index', align: 'center', width: "4%",
                },
                {
                    key: 'medicalDept', title: this.$t('itemslist_table_dept'), dataIndex: 'medicalDept', align: 'start',
                    customRender: ({text, record}) => {
                        return this.convertDeptToText(record.medicalDept)
                    },
                },
                {
                    key: 'productType', title: this.$t('itemslist_table_type'), dataIndex: 'productType', align: 'start',
                    customRender: ({text, record}) => {
                        return record.productType || '-';
                    },
                },
                {
                    key: 'itemCode', title: this.$t('itemslist_table_itemcode'), dataIndex: 'itemCode', align: 'start',
                    customRender: ({text, record}) => {
                        return record.itemCode || '-';
                    },
                },
                {
                    key: 'itemName', title: this.$t('itemslist_table_itemname'), dataIndex: 'itemName', align: 'start',
                    customRender: ({text, record}) => {
                        return record.itemName || '-';
                    },
                },
                {
                    key: 'warrantyStatus', title: this.$t('itemslist_table_unregister'), dataIndex: 'warrantyStatus', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div class="status-wrap-align">
                                <span class="status-wrap">
                                {
                                    record.unregisterYn === enums().YnEnum.Y
                                        ? this.$t('itemslist_table_allow')
                                        : this.$t('itemslist_table_notallow')
                                }
                                </span>
                            </div>
                        );
                    },
                },
                {
                    key: 'duplicateYn', title: this.$t('itemslist_table_dup'), dataIndex: 'duplicateYn', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div class="status-wrap-align">
                                <span class="status-wrap">
                                {
                                    record.duplicateYn === enums().YnEnum.Y
                                        ? this.$t('itemslist_table_allow')
                                        : this.$t('itemslist_table_notallow')
                                }
                                </span>
                            </div>
                        );
                    },
                },
                {
                    key: 'itemCount', title: this.$t('itemslist_table_itemcount'), dataIndex: 'itemCount', align: 'center',
                    customRender: ({text, record}) => {
                        return this.formatCommaNumber(record.itemCount)
                    },
                },
                {
                    key: 'modify-button', title: this.$t('itemslist_table_modify'), dataIndex: '_id', align: 'center',
                    customRender: ({text, record}) => {
                        return (
                            <div
                                style="width: 100%; justify-content: center; display: flex;"
                            >
                                <a-button 
                                    shape="circle"
                                    onClick={() => {
                                        this.routeToModifyItemPage(record._id);
                                    }}
                                    icon={<i class="fa-regular fa-pen-to-square" />}
                                />  
                            </div>
                        )
                    },
                },
                {
                    key: 'delete-button', title: this.$t('itemslist_table_delete'), dataIndex: '_id', align: 'center',
                    customRender: ({text, record}) => {
                        if(record.isDeleted) {
                            return '';
                        }
                        return (
                            <div
                                style="width: 100%; justify-content: center; display: flex;"
                            >
                                <a-button 
                                    shape="circle"
                                    onClick={() => this.deleteItem(record._id)}
                                    icon={<i class="fa-solid fa-trash-can" />}
                                />    
                            </div>
                        )
                    },
                },
            ],

        listSize: 0,
        rowsPerPage: 10, // Default, can be changed by the user
        paginationData: {
            currentPage: 1, 
            totalPages: 0,
        },
        };
    },
    async mounted() {
        await this.getDeptList();
        this.checkIsZeiss();

        const obj = {};
        obj.page = this.paginationData.currentPage;
        this.paginationHandler(obj);
    },
    methods: {
        convertDate,
        checkIsZeiss() {
            const companyId = jwtDecoder(getAccessToken());
            if(companyId && companyId === process.env.VUE_APP_ZEISS_ID) {
                this.isZeiss = true;
            }
        },
        routeToAddItem() {
            this.$router.push(this.addItemPath);
        },
        // 주요 API
        async paginationHandler(childPassParam) {
            this.paginationData.currentPage = childPassParam.page;
            await this.getItemsList();
        },
        //삭제 공통 confirm 모달
        async deleteItem(itemId) {
            this.selectedItem = itemId;
            try {
                const confirmResult = await confirmDialog(this.$i18n.t('itemslist_delete_title'), this.$i18n.t('itemslist_delete_msg'));
                if (confirmResult) {
                const response = await this.$apiInstance.delete(`/items/${this.selectedItem}`);
                if (response.status === 200 || response.status === 201) {
                    await oneBtnDialog(this.$i18n.t('itemslist_delete_done_title'), this.$i18n.t('itemslist_delete_done_content'), true);
                }
                }
            } catch(error) {
                console.log(error);
                await oneBtnDialog(this.$i18n.t('itemslist_delete_fail_title'), this.$i18n.t('itemslist_delete_fail_content'), false);
            }
        },
        // 과 목록 가져오기
        async getDeptList() {
            try {
                const response = await this.$apiInstance.get(`/items/medical/depts`);
                if (response.status === 200 || response.status === 201) {
                    this.deptList = response.data.filter(item => item.code !== MedicalDept.COMMON);
                }
            } catch (error) {
                console.log(error);
                await oneBtnDialog(this.$i18n.t('hospitalw_message_get_dept_title'),this.$i18n.t('hospitalw_message_get_dept_content'), false);
            }
        },
        async enter() {
            if (this.searchFilter === '') {
                await oneBtnDialog(this.$i18n.t('productslist_search_empty_filter_err_title'), this.$i18n.t('productslist_search_empty_filter_err_content'), false);
            } else {
                this.paginationData.currentPage = 1;
                this.getItemsList();
            }
        },
        // 품목 리스트 가져오기
        async getItemsList() {
            const params = {};
            if(this.previousCondition !== this.condition) {
                params.page = 1;
            } else {
                params.page = this.paginationData.currentPage;
            }
            params.limit = this.rowsPerPage;
            if (this.searchFilter !== '' && this.condition !== '') {
                params.search = this.searchFilter;
                params.condition = this.condition;
            }
            try {
                const response = await this.$apiInstance.get(`/items`, { params });
                if (response.status === 200 || response.status === 201) {
                this.calledApiTimes ++;

                if(this.previousCondition !== this.condition) {
                    this.paginationData.currentPage = 1;
                } 
                this.previousCondition = this.condition;
                if(response.data.docs) {
                    this.responseData = response.data.docs;
                } else {
                    this.responseData = [];
                }
                this.listSize = response.data.totalDocs;
                for (let i = 0; i < this.responseData.length; i++) {
                    this.responseData[i].index = this.listSize - (this.paginationData.currentPage - 1) * this.rowsPerPage  - i;
                }
                this.paginationData.totalPages = response.data.totalPages;
            }
        } catch (error) {
            console.log(error);
            await oneBtnDialog(this.$i18n.t('itemslist_err_title'), this.$i18n.t('itemslist_err_content'), false);
        }
        },

        // 품목 상세
        async routeToModifyItemPage(itemId) {
            this.$router.push({name: 'ModifyItem', params: { itemId },});
        },
        async handleRowsPerPage() {
            this.paginationData.currentPage = 1;
            await this.getItemsList();
        },
        // 인증서 상태 코드 텍스트로 변환
        // 과명 변환
        convertDeptToText(code) {
            const department = this.deptList.find((item) => item.code === code);
            return department ? department.name : '-';
        },
    },
};
</script>
<style lang="scss" scoped>

@media screen and (max-width:767px) {
    .search-container {
        gap: 8px !important;
        .search-div {
            flex-direction: row;
            gap: 0px;
            .ant-select{
                width: 150px !important;
            }
            .typing-area{
                width: 100%;
                gap: 0;
            }
        }
    }

    .container-fluid .row.justify-content-center{
        padding: 14px 14px 36px 14px !important;
    }
    .mainDiv{
        width: 100% !important;
    }
    .header-btn{
        margin-left: auto;
    }
    .table-with-search .table-info-filter{
        flex-direction: column;
        align-items: flex-start;
        flex: none;
        justify-content: flex-start;
        height: 210px;
    }

    .table-with-search .search-container .search-div input,
    .table-with-search .search-container .search-div button{
        width: 60px !important;
        min-width: auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
    }

    .table-with-search .search-container .search-div input{
        width: calc(100% - 60px)!important;
    }

    #searchFilter{
        display: flex;
        flex-wrap: row;
    }
    .table-with-search .search-container,
    .table-with-search .search-container .search-div,
    .table-with-search .search-container select{
            width: 100%;
            flex: none;
        }
}

@media screen and (min-width:768px) and (max-width:1023px){
    .table-with-search .table-info-filter{
        flex-direction: column;
        width: 100%;
        .total-div{
            margin-right: auto;
        }
        .search-container{
            width: 100%;
            flex-direction: row;
            .search-div{
                flex-direction: row;
                width: 100%;
                input{
                width: calc(100% - 80px) !important;
                }
                .search-btn{
                min-width: 80px;
                }
            }
        }
    }
}
</style>
